import AccessRequests from '../collections/AccessRequests';
import { baseApi } from 'core/api';

const state = () => ({
    _accessRequests: null,
    _parameters: {
        sortBy: 'created_at',
        sortOrder: 'desc',
    },
    _loading: false,
});

const getters = {
    accessRequests: (state) => state._accessRequests,
    accessRequestsLoading: (state) => state._loading,
    accessRequestsParameters: (state) => state._parameters,
};

const actions = {
    getUsersAccessRequests({ retry = false } = {}) {
        if (this._loading) return;

        this._setAccessRequestsLoading(true);

        if (retry === true) {
            this._setAccessRequestsLoadRetry();
        }

        return baseApi
            .get('core/users/access-requests')
            .then((response) => {
                this._setAccessRequestsLoaded(response.data);
                return response;
            })
            .catch((error) => {
                this._setAccessRequestsLoadError();
                return error;
            })
            .finally(() => {
                this._setAccessRequestsLoading(false);
            });
    },

    accessRequestsSortUpdate(sort) {
        if (sort.sortBy !== 'actions') {
            let accessRequests = [...(this._accessRequests || [])];

            const sortData = (sortBy, sortOrder) => {
                if (sortOrder === 'asc') {
                    return (a, b) => {
                        if (sortBy === 'fullName') {
                            return a[sortBy].toLowerCase() > b[sortBy].toLowerCase() ? 1 : -1;
                        }
                        return a.user[sortBy] > b.user[sortBy] ? 1 : -1;
                    };
                }

                return (a, b) => {
                    if (sortBy === 'fullName') {
                        return a[sortBy].toLowerCase() < b[sortBy].toLowerCase() ? 1 : -1;
                    }
                    return a.user[sortBy] < b.user[sortBy] ? 1 : -1;
                };
            };

            accessRequests.sort(sortData(sort.sortBy, sort.sortOrder));

            let fullfilledAccessRequests = [];
            let emptyAccessRequests = [];

            if (sort.sortBy === 'fullName') {
                // Custom filter for first_name type with empty last_name
                fullfilledAccessRequests = accessRequests.filter(
                    (accessRequest) => accessRequest.fullName
                );
                emptyAccessRequests = accessRequests.filter(
                    (accessRequest) => !accessRequest.fullName
                );
            } else {
                // Default filter for empty fields
                fullfilledAccessRequests = accessRequests.filter(
                    (accessRequest) => accessRequest.user[sort.sortBy] !== null
                );
                emptyAccessRequests = accessRequests.filter(
                    (accessRequest) => accessRequest.user[sort.sortBy] === null
                );
            }

            const filteredAccessRequests =
                sort.sortOrder === 'asc'
                    ? [...emptyAccessRequests, ...fullfilledAccessRequests]
                    : [...fullfilledAccessRequests, ...emptyAccessRequests];

            this._setAccessRequestsSortUpdate(sort);
            this._setAccessRequestsLoadedRaw(filteredAccessRequests);
        } else {
            const requestTypes = {
                1: 'Update',
                2: 'Approve',
                3: 'Invite',
            };

            let accessRequests = [...(this._accessRequests || [])];

            const sortData = (sortOrder) => {
                if (sortOrder === 'asc')
                    return (a, b) =>
                        requestTypes[a.request_type] > requestTypes[b.request_type] ? 1 : -1;
                return (a, b) =>
                    requestTypes[a.request_type] < requestTypes[b.request_type] ? 1 : -1;
            };

            accessRequests.sort(sortData(sort.sortOrder));

            this._setAccessRequestsSortUpdate(sort);
            this._setAccessRequestsLoadedRaw(accessRequests);
        }
    },

    _setAccessRequestsLoaded(data) {
        const accessRequests = new AccessRequests(data);
        this._accessRequests = accessRequests.models;
    },

    _setAccessRequestsLoadedRaw(accessRequestsArray) {
        this._accessRequests = accessRequestsArray;
    },

    _setAccessRequestsLoading(status) {
        this._loading = status;
    },

    _setAccessRequestsLoadRetry() {
        this._accessRequests = null;
    },

    _setAccessRequestsLoadError() {
        this._accessRequests = false;
    },

    _setAccessRequestsSortUpdate(data) {
        this._parameters.sortBy = data.sortBy;
        this._parameters.sortOrder = data.sortOrder;
    },
};

export default {
    state,
    getters,
    actions,
};
